// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10vAf","inner":"Footer_inner__1m81Z","nextIcon":"Footer_nextIcon__1zeV-","innerLeft":"Footer_innerLeft__3185j"};